import { Link } from '@zoopla-eng/zds/link';
import React from 'react';
import { agentLogoImageStyle } from './agent-logo.styles.css';

type AgentLogoProps = {
    title?: string | null;
    href?: string | null;
    onClick?: () => void;
    src?: string | null;
};

const AgentLogo: React.FC<AgentLogoProps> = ({ href, title, onClick, src }) => {
    return title && href && src && src !== 'false' ? (
        <Link
            data-testid="listing-details-agent-logo"
            href={href}
            title={`Visit ${title} branch page.`}
            onClick={onClick}
        >
            <img className={agentLogoImageStyle} src={src} alt={title} />
        </Link>
    ) : null;
};

export { AgentLogo };
